export const GRAY_BASE = "#000000";
export const GRAY_DARKER = "#1A1A1A";
export const GRAY_DARK = "#232323";
export const GRAY_DARKER_MID = "#333333";
export const GRAY_DARK_MID = "#424242";
export const GRAY_MID = "#7a7a7a";
export const GRAY_LIGHT = "#9e9e9e";
export const GRAY_LIGHTER = "#bdbdbd";

export const BLUE_BASE = "#2e97c2"; //rgba(46,151,194,1)
export const BLUE_90 = "rgba(46,151,194,0.9)";
export const BLUE_80 = "rgba(46,151,194,0.8)";
export const BLUE_70 = "rgba(46,151,194,0.7)";
export const BLUE_60 = "rgba(46,151,194,0.6)";
export const BLUE_50 = "rgba(46,151,194,0.5)";
export const BLUE_40 = "rgba(46,151,194,0.4)";
export const BLUE_30 = "rgba(46,151,194,0.3)";
export const BLUE_20 = "rgba(46,151,194,0.2)";
export const BLUE_10 = "rgba(46,151,194,0.1)";
export const BLUE_05 = "rgba(46,151,194,0.05)";
export const BLUE_0 = "rgba(46,151,194,0)";
export const BLUE_LIGHT = "#77c1df";

export const WHITE = "rgba(255,255,255,1)";
export const WHITE_10 = "rgba(255,255,255,0.1)";
export const WHITE_30 = "rgba(255,255,255,0.3)";
export const WHITE_50 = "rgba(255,255,255,0.5)";
export const WHITE_005 = "rgba(255,255,255,0.05)";

export const WARNING = "#F9CE30";
export const ERROR = "#a94442";
export const BORDER_GRAY = "#aaaaaa";

//CONTEXT FOR COLORS
export const ACTION = BLUE_BASE;
export const BORDER = GRAY_DARK;
export const BACKGROUND = GRAY_DARKER;
export const SELECTED_TEXT = BLUE_40;
export const PRIMARY_TEXT = GRAY_LIGHTER;
export const SECONDARY_TEXT = GRAY_MID;
export const ALT_TEXT = GRAY_MID;
export const SCROLLBAR_THUMB = GRAY_DARK_MID;
export const LABEL_TEXT = GRAY_MID;

export default {
  GRAY_BASE,
  GRAY_DARKER,
  GRAY_DARK,
  GRAY_DARKER_MID,
  GRAY_DARK_MID,
  GRAY_MID,
  GRAY_LIGHT,
  GRAY_LIGHTER,
  BORDER_GRAY,
  BLUE_BASE,
  BLUE_90,
  BLUE_80,
  BLUE_70,
  BLUE_60,
  BLUE_50,
  BLUE_40,
  BLUE_30,
  BLUE_20,
  BLUE_10,
  BLUE_05,
  BLUE_0,
  BLUE_LIGHT,
  WHITE,
  WHITE_10,
  WHITE_30,
  WHITE_50,
  WHITE_005,
  ACTION,
  BORDER,
  BACKGROUND,
  ERROR,
  SELECTED_TEXT,
  PRIMARY_TEXT,
  SECONDARY_TEXT,
  ALT_TEXT,
  WARNING,
  SCROLLBAR_THUMB,
  LABEL_TEXT,
};
